"use client"

import { ArrowDownWideNarrow } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowDownWideNarrowIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowDownWideNarrowIcon = component(Icon)({
  as: ArrowDownWideNarrow,
})
